// api.js
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const WS_URL = process.env.REACT_APP_WS_URL;
export const API_KEY = process.env.REACT_APP_API_KEY;

// Helper for authenticated REST API requests
export const authenticatedFetch = async (url, options = {}) => {
  const headers = {
    "x-api-key": API_KEY,
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  return fetch(url, {
    ...options,
    headers,
  });
};

// Helper for authenticated WebSocket connections
export const getAuthenticatedWSUrl = (sessionId) => {
  return `${WS_URL}?api_key=${API_KEY}&sessionId=${sessionId}`;
};
